import { startSetChecks } from "./checks";
import { startSetProbers } from "./probers";
import axios from "axios";
import { history } from "../routers/AppRouter";
import { hostServer } from "./consts/host";
import { message } from "antd";
import { changeFetchInProg } from "./fetchInProgress";
import { startGettingSubscriptions } from "./plans";

export const login = (user) => ({
  type: "LOGIN",
  user,
});

export const updateProfile = (profile) => ({
  type: "UPDATE_PROFILE",
  profile,
});

// export const setAlertsData = data => ({
//   type: "SET_ALERT_DATA",
//   data
// });

export const setLabelsData = (data) => ({
  type: "SET_LABELS_DATA",
  data,
});

export const logout = () => ({
  type: "LOGOUT",
});

export const startSetLabelsData = (labels) => {
  return async (dispatch) => {
    dispatch(setLabelsData(labels));
  };
};

export const startLogin = (user = "", pass = "", token) => {
  return async (dispatch) => {
    const json = {
      email: user,
      password: pass,
    };
    dispatch(changeFetchInProg(true));
    try {
      const header = {};
      let key = null;
      // check token existance for impersonate and if null for oAuth
      if (token) {
        header.headers = {
          Authorization: `Token ${token}`,
        };
        key = token;
      } else {
        const res = await axios.post(`${hostServer}/api/v1/users/login`, json);
        header.headers = {
          Authorization: `Token ${res.data.key}`,
        };
        key = res.data.key;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "login",
      });

      const { data } = await axios.get(`${hostServer}/api/v1/users/profile`, header);
      dispatch(login({ ...data, uid: key }));
      if (data.is_verified) {
        localStorage.setItem("user", JSON.stringify({ token: key }));
        dispatch(startSetChecks());
        dispatch(startSetProbers());
      }
    } catch (e) {
      message.warning("No user with username/password entered found!");
    }
    await dispatch(startGettingSubscriptions());

    dispatch(changeFetchInProg(false));
  };
};

export const startGettingProfile = () => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    try {
      const { data } = await axios.get(`${hostServer}/api/v1/users/profile`, header);
      dispatch(updateProfile(data));
    } catch (e) {}
    dispatch(changeFetchInProg(false));
  };
};

export const startLoginAsGuest = (user = "", pass = "") => {
  return async (dispatch) => {
    dispatch(changeFetchInProg(true));
    try {
      const res = await axios.get(`${hostServer}/api/v1/users/login_as_demo`);
      const header = {
        headers: {
          Authorization: `Token ${res.data.key}`,
        },
      };
      const { data } = await axios.get(`${hostServer}/api/v1/users/profile`, header);
      dispatch(login({ ...data, uid: res.data.key }));
      if (data.is_verified) {
        dispatch(startSetChecks());
        dispatch(startSetProbers());
      } else {
        message.warning("You are not verified yet.We will contact you soon!");
      }
    } catch (e) {
      message.warning("No user with username/password entered found!");
    }
    await dispatch(startGettingSubscriptions());

    dispatch(changeFetchInProg(false));
  };
};

export const startRegister = (user = "", pass = "") => {
  return async (dispatch) => {
    dispatch(changeFetchInProg(true));
    const json = {
      email: user,
      password: pass,
    };
    try {
      await axios.post(`${hostServer}/api/v1/users/register`, json);
      dispatch(startLogin(user, pass));

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "sign_up",
      });
    } catch (e) {
      message.warning(e.response.data.error);
    }
    dispatch(changeFetchInProg(false));
  };
};

export const startVerifyEmail = (email, token) => {
  return async (dispatch) => {
    dispatch(changeFetchInProg(true));
    try {
      const json = {
        email,
        token,
      };
      const { data } = await axios.post(`${hostServer}/api/v1/users/verify_email`, json);
      await dispatch(startLogin(undefined, undefined, data.result));
      history.push(`/`);
    } catch (e) {}
    dispatch(changeFetchInProg(false));
  };
};

export const startResendEmail = (email) => {
  return async (dispatch) => {
    dispatch(changeFetchInProg(true));
    try {
      const json = {
        email,
      };
      await axios.post(`${hostServer}/api/v1/users/send_verification_token`, json);
    } catch (e) {}
    dispatch(changeFetchInProg(false));
  };
};

export const startLogout = () => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    await axios.post(`${hostServer}/api/v1/users/logout`, {}, header);
    dispatch(logout());
    localStorage.removeItem("user");
    dispatch(changeFetchInProg(false));
    history.push("/login");
  };
};

export const startSetAlertsData = (data) => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    const json = {
      id: getState().auth.id,
      email: getState().auth.email,
      alert_channels: data,
    };
    try {
      await axios.put(`${hostServer}/api/v1/users/profile`, json, header);
      dispatch(changeFetchInProg(false));
      dispatch(startGettingProfile());
    } catch (e) {
      message.error("Something went wrong!");
    }
    dispatch(changeFetchInProg(false));
  };
};

export const startForgetPass = (email) => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    const json = {
      email,
    };
    try {
      await axios.post(`${hostServer}/api/v1/users/send_forget_password_email`, json);
      message.success("We send you a reset password link");
      history.push(`/login`);
    } catch (e) {
      message.warning(e.response.data.error);
    }
    dispatch(changeFetchInProg(false));
  };
};

export const startResetPass = (token, email, password) => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    const json = {
      token,
      email,
      password,
    };
    try {
      await axios.post(`${hostServer}/api/v1/users/reset_password`, json);
      message.success("Your password successfully changed!");
      history.push("/");
    } catch (e) {
      message.error("Something went wrong!");
    }
    dispatch(changeFetchInProg(false));
  };
};

export const requestToken = (channel_type, value) => {
  return async (dispatch, getState) => {
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    const json = {
      channel_type,
      value,
    };
    try {
      await axios.post(`${hostServer}/api/v1/users/alert_channel/send_token`, json, header);
      message.success(`We sent a verification code to ${value}`);
      return true;
    } catch (e) {
      message.error("Something went wrong!");
      return false;
    }
  };
};

export const startVerifyChannel = (channel_type, value, token) => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    const header = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`,
      },
    };
    const json = {
      channel_type,
      value,
      token,
    };
    try {
      await axios.post(`${hostServer}/api/v1/users/alert_channel/verify`, json, header);
      message.success(`Your ${channel_type} is now verified!`);
      dispatch(changeFetchInProg(false));
      dispatch(startGettingProfile());
      return true;
    } catch (e) {
      message.error("Something went wrong!");
      dispatch(changeFetchInProg(false));
      return false;
    }
  };
};
